window.FormHandler = class {
	constructor(form, ev, opt = {}) {

		this.formData = new FormData(form);
		this.event = ev;
		this.options = $.extend({
			ladda: true,
		}, opt);

		this.form = form;

		let temp = {};

		function manipulateValue(value, input) {

			// Verifica si el campo tiene el plugin intlTelInput y obtiene el valor internacional
			if (input?.dataset?.plugin === 'intlTelInput') {
				// Usa el método getNumber para obtener el valor internacional del campo
				const iti = intlTelInput.getInstance(input);
				value = iti.getNumber();
				console.log(input, iti.getNumber());
			}


			if (input?.type === 'tel') {
				// Si el tipo es 'tel' o el formato es 'phone', filtrar los caracteres no numéricos o '+'
				return value.replace(/[^\d+]/g, '');
			}
			// Remover caracteres especiales que simulan ser espacio
			return value.replace(/[\u00A0\u2000-\u200B\u202F\u205F\u3000]/g, ' ');
		}

		// Recorrer cada entrada en el FormData
		for (var pair of this.formData.entries()) {
			const key = pair[0];
			const value = pair[1];
			const input = $(form).find(`[name='${key}']`).get(0); // Encuentra el input correspondiente

			// Comprobar si la clave termina en '[]', lo que indica un array
			if (key.endsWith('[]')) {
				// Si no existe un array para esta clave, crearlo
				if (!temp[key]) {
					temp[key] = [];
				}
				// Añadir el valor al array correspondiente, manipulando según el formato
				temp[key].push(manipulateValue(value, input));
			} else {
				// Para campos no-array, manipular y guardar el valor
				temp[key] = manipulateValue(value, input);
			}
		}

		// Ahora procesar los arrays
		for (let key in temp) {
			// Eliminar la entrada original del FormData
			this.formData.delete(key);

			if (Array.isArray(temp[key])) {
				// Aquí manipula los valores del array
				let manipulatedArray = temp[key].map(val => manipulateValue(val));
				// Añadir de nuevo los valores al FormData
				manipulatedArray.forEach(val => this.formData.append(key, val));
			} else {
				this.formData.append(key, temp[key]);
			}
		}
	};

	set(key,value) {
		this.formData.set(key,value);
	}

	get(key) {
		return this.formData.get(key);
	};

	getAll() {
		let arr = {};
		for (var pair of this.formData.entries()) {
			arr[pair[0]] = pair[1];
		}
		return arr;
	};

	convertDate(key, from, to) {
		if(this.get(key) !== undefined)
			this.set(key, moment( this.get(key), from ).format(to));
	}

	serialize() {
		return new URLSearchParams( this.formData ).toString();
	};

	lock() {
		if ("vibrate" in navigator) {
			navigator.vibrate(1);
		}

		if ($(this.form).data('submitting') == true) return true;
		$(this.form).data('submitting', true);

		if (this.options.ladda) {
			let submitButton = null;

			if (this.event !== undefined && this.event.originalEvent && this.event.originalEvent.submitter) {
				submitButton = this.event.originalEvent.submitter;
			} else {
				submitButton = $(this.form).find('[type="submit"]')[0];
			}

			if (submitButton) {
				Ladda.create(submitButton).start();
			} else {
				console.warn("No se pudo encontrar el botón submit para iniciar Ladda.");
			}
		}

		return false;
	}

	unlock() {
		$(this.form).data('submitting', false);
		if (this.options.ladda) {
			let submitButton = null;

			if (this.event !== undefined && this.event.originalEvent && this.event.originalEvent.submitter) {
				submitButton = this.event.originalEvent.submitter;
			} else {
				submitButton = $(this.form).find('[type="submit"]')[0];
			}
			if (submitButton) {
				Ladda.create(submitButton).stop();
			} else {
				console.warn("No se pudo encontrar el botón submit para finalizar Ladda.");
			}
		}
	};

	clear() {
		this.form.reset();
	};
}
